/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import { useInput, useRecordContext } from 'react-admin';
import {
  Box,
  ToggleButton,
  Typography,
  useTheme,
} from '@mui/material';
import StyledToggleButtonGroup from '../layout/button/StyledToggleButtonGroup';
import permissionIconNames, { iconNameIconMap, PermissionIconName } from '../../constants/permissionIconNames';
import { ReformedPermissionRole } from './type';

const PermissionRoleIconInput = ({ source, label }: { source: string; label: string }) => {
  const record = useRecordContext<ReformedPermissionRole>();
  const theme = useTheme();
  const { field } = useInput({
    source,
    defaultValue: record?.iconName ?? permissionIconNames.PERSON_FILLED,
  });

  const handleChange = useCallback((
    _event: React.MouseEvent<HTMLElement>,
    newIcon: PermissionIconName,
  ) => {
    if (newIcon) {
      field.onChange(newIcon);
    }
  }, [field]);
  if (!record) return null;

  return (
    <Box display="flex" flexDirection="column" gap={2} marginY={2}>
      <Typography variant="label">{label}</Typography>
      <StyledToggleButtonGroup
        {...field}
        exclusive
        onChange={handleChange}
        value={field.value}
        sx={{
          gap: 2,
          display: 'flex',
          flexWrap: 'wrap',
          '& .MuiToggleButton-root': {
            border: 1,
            borderColor: theme.palette.grey[400],
            padding: 2,
            borderRadius: 4,
            backgroundColor: theme.palette.greenGray.main,

            '&.Mui-selected': {
              backgroundColor: theme.palette.secondary.main,
              color: theme.palette.primary.contrastText,
            },
          },
        }}
      >
        {Object.entries(iconNameIconMap).map(([iconName, icon]) => (
          <ToggleButton
            key={iconName}
            value={iconName}
          >
            {React.createElement(icon)}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </Box>
  );
};

export default PermissionRoleIconInput;
